import { localOnlyNoteOf } from "@buildpy/core/modules/quote/editor/saved-elsewhere";
import { Button } from "@buildpy/ui/button";

// 잠긴 본문 fieldset 의 aria-describedby 가 가리키는 배너 문구 — 편집기는 한 화면에 하나뿐이다.
export const LOCKED_NOTE_ID = "quote-locked-note";

// 잠겼을 때만 fieldset 을 배너 문구로 설명한다.
export const lockedDescribedBy = (locked: boolean | undefined): string | undefined => (locked ? LOCKED_NOTE_ID : undefined);

interface Props {
  note: string;
  onCopy: () => void;
  onLeave: () => void;
  onReload: () => void;
}

// 발송 등으로 잠긴 편집기의 배너(폰·데스크톱 공용) — 알림 읽기는 편집기의 live 영역, 이 글은 보이고 읽히는 정적 문구.
const LockedBanner = ({ note, onCopy, onLeave, onReload }: Props) => (
  <div className="flex flex-wrap items-center justify-between gap-2 rounded-md border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive">
    <span id={LOCKED_NOTE_ID}>{localOnlyNoteOf(note)}</span>
    <span className="flex flex-wrap items-center gap-2">
      <Button size="sm" variant="outline" onClick={onReload}>
        새로 불러오기
      </Button>
      <Button size="sm" variant="outline" onClick={onCopy}>
        편집 내용 복사
      </Button>
      <Button size="sm" variant="outline" onClick={onLeave}>
        상세로 가기
      </Button>
    </span>
  </div>
);

export default LockedBanner;
